export default {
  title: "Privacy Policy",
  eyebrow: "Legal · Privacy",
  updated: "June 2026",
  sections: [
    {
      id: "who-we-are",
      label: "Who we are",
      heading: "1. Who we are",
      blocks: [
        { p: 'BeaconShield ("we", "us") is a mobile app that shows live, crowdsourced emergency room and walk-in clinic wait times in Canada. Contact: <a href="mailto:BeaconShieldApp@gmail.com">BeaconShieldApp@gmail.com</a>.' },
      ],
    },
    {
      id: "information-we-collect",
      label: "Information we collect",
      heading: "2. Information we collect",
      blocks: [
        { p: "<strong>Account information:</strong> your email address, display name, and profile picture when you sign up with Google or create an account with email and password. Passwords are stored only as a salted bcrypt hash — never in plain text. For Google sign-ins we also store your numeric Google account identifier." },
        { p: "<strong>Location:</strong> with your permission, the app uses your device's GPS on-device only to find nearby hospitals, sort them by distance, and estimate drive times. We never store your GPS coordinates on our servers. When you check in for a hospital trip, we save only the hospital you chose, the estimated driving minutes, and the distance in kilometres." },
        { p: "<strong>Hospital activity:</strong> wait-time reports you submit (hospital, reported wait, timestamp), reviews and ratings you write, favourites, hospital views, share events, arrival check-ins, wait alerts you set, and names of family members you add for alerts (names only — we collect no contact details for them)." },
        { p: "<strong>AI triage chat:</strong> messages you send to the in-app AI assistant and its replies are saved as chat history you can view and delete inside the app. Because you may describe symptoms, treat these chats as health-related information. If a message contains emergency terms, we log the detection with a one-way hashed IP address (never the raw IP) for safety auditing." },
        { p: '<strong>Device and security data:</strong> device model and platform (for example "Pixel 8 · Android") for each login session, shown in your account\'s device list and used to email you about new-device sign-ins. Session tokens expire after 7 days.' },
      ],
    },
    {
      id: "how-we-use",
      label: "How we use your information",
      heading: "3. How we use your information",
      blocks: [
        { p: "To show accurate wait times, power community features (reports, reviews, streaks, badges, leaderboards, referrals), send the emails you request (weekly impact digest, password resets, new-device alerts), personalise your experience, respond to support requests, and keep the service safe." },
      ],
    },
    {
      id: "what-we-do-not-collect",
      label: "What we do NOT collect",
      heading: "4. What we do NOT collect",
      blocks: [
        { p: "No stored GPS location history, no contacts, no photos, no advertising identifiers, no payment information, no official health records. We do not sell or rent personal information to anyone, and we do not use your data for third-party advertising." },
      ],
    },
    {
      id: "sharing",
      label: "Who we share data with",
      heading: "5. Who we share data with",
      blocks: [
        { p: "We use a small number of service providers to run BeaconShield: Google (sign-in authentication), Google Maps (map display), OpenAI/Anthropic via a managed AI service (processing triage chat messages), and Resend (email delivery). Each receives only what is necessary to perform its function. We may disclose information if required by law." },
      ],
    },
    {
      id: "retention",
      label: "Data retention",
      heading: "6. Data retention",
      blocks: [
        { p: "Account data is kept while your account is active. Wait reports and reviews persist as anonymised community data. AI chat history is kept until you delete it in the app. Session records expire automatically after 7 days." },
      ],
    },
    {
      id: "deleting-your-data",
      label: "Deleting your data",
      heading: "7. Deleting your data",
      blocks: [
        { p: 'You can permanently delete your account and all associated data at any time from <strong>Settings → Delete account</strong> inside the app, or by emailing <a href="mailto:BeaconShieldApp@gmail.com">BeaconShieldApp@gmail.com</a>. Deletion removes your profile, chats, reports attribution, favourites, alerts, and family members.' },
      ],
    },
    {
      id: "security",
      label: "Security",
      heading: "8. Security",
      blocks: [
        { p: "Data is transmitted over HTTPS/TLS, passwords are bcrypt-hashed, login codes are single-use and short-lived, and access to production systems is restricted." },
      ],
    },
    {
      id: "children",
      label: "Children",
      heading: "9. Children",
      blocks: [{ p: "BeaconShield is not directed at children under 13 and we do not knowingly collect their information." }],
    },
    {
      id: "canadian-privacy-law",
      label: "Canadian privacy law",
      heading: "10. Canadian privacy law",
      blocks: [
        { p: "We handle personal information in accordance with PIPEDA (Personal Information Protection and Electronic Documents Act). You may request access to or correction of your personal information by contacting us." },
      ],
    },
    {
      id: "health-disclaimer",
      label: "Important health disclaimer",
      heading: "11. Important health disclaimer",
      blocks: [
        { p: "BeaconShield provides community-reported wait estimates and AI-generated general information only — it is not medical advice. In an emergency, always call 911." },
      ],
    },
    {
      id: "changes",
      label: "Changes",
      heading: "12. Changes",
      blocks: [{ p: "We will post any material changes to this page and update the date above." }],
    },
    {
      id: "contact",
      label: "Contact",
      heading: "13. Contact",
      blocks: [{ p: '<a href="mailto:BeaconShieldApp@gmail.com" data-testid="privacy-contact-email">BeaconShieldApp@gmail.com</a>' }],
    },
  ],
};
